<template>
    <BrandForm @cancel="close" :parent-loading="loading" @save="save" :type="FORM_TYPE.create" :brand="brand"> </BrandForm>
</template>

<script>
import brandService from "@/services/brand";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import BrandForm from "@/components/admin/brand/BrandForm";
import { FORM_TYPE, serializeBrand } from "@/components/admin/brand/utils/brandFormUtils";

export default {
    data() {
        return {
            FORM_TYPE,
            brand: {}
        };
    },
    mixins: [TryLoadMixin],
    components: { BrandForm },
    methods: {
        async save(brand) {
            const brandSerialized = await serializeBrand(brand);
            await this.tryLoad(() => brandService.createBrand(brandSerialized));
            this.dialogSuccess(this.$trad.brand.successCreateTxt);
            this.close();
        },
        close() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// CreateBrand.vue?52611f57